// extracted by mini-css-extract-plugin
module.exports = {"Screen":"Loading_Screen__1BKxr","loader":"Loading_loader__1xzHQ","spin":"Loading_spin__ZY11s"};